import React, { ReactNode, FC, memo } from 'react'
import { DatePicker } from 'components/forms/DatePicker'

interface DriverLocationProps {
  children: ReactNode
}

const DriverLocation: FC<DriverLocationProps> = ({ children }) => (
  <section className='mt6'>
    <div className='b mb4'>Empty Location &amp; ETA</div>
    {children}
  </section>
)

export default DriverLocation

interface IPickupDate {
  onDateChange: (date: string[]) => void
}

export const PickupDate = memo<IPickupDate>(({ onDateChange }) => (
  <div>
    <label htmlFor='etaDate' className='label required'>
      ETA Date
    </label>
    <DatePicker onDateChange={onDateChange} id='etaDate' dataTest='input-etaDate' />
  </div>
))
